import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CONSTANTS } from 'src/app/core/config/constants';
import { Observable } from 'rxjs';
import { CommonService } from 'src/app/core/helper/common.service';
import { LocalStorageService } from '../../core/helper/local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class SupportService {
    constructor(private httpClient: HttpClient,
        private commonService: CommonService,
        private localStorageService: LocalStorageService) { }

    /**
     * get support list
     * @param requestData 
     * @returns 
     */
    getSupportList(requestData): Observable<any> {
        //sort params
        var order_on = ""
        if (requestData.order_on != null) {
            order_on = "&order_on=" + encodeURIComponent(requestData.order_on);
        }
        var order_by = "";
        if (requestData.order_by != null) {
            order_by = "&order_by=" + encodeURIComponent(requestData.order_by);
        }

       
        // status
        var status = "";
        if(requestData.status != null){
            status = "&ticket_status_id=" + encodeURIComponent(requestData.status)
        }

        // priority
        var priority = "";
        if(requestData.priority != null){
            priority = "&priority=" + encodeURIComponent(requestData.priority)
        }
        
        //search value
        var search_value = "";
        var regex = /[?=+]/g;
        search_value = '&search=' + encodeURIComponent(requestData.search_value.replace(regex, ""));

      
        return this.httpClient.get(CONSTANTS.APP.BASE_API_URL_ATUHENTICATION + CONSTANTS.API.ROUTE.SUPPORT.LIST + "/?pageno=" + requestData.pageno + "&pagesize=" + requestData.pagesize + priority + status + order_by + order_on + search_value );
    }

    /**
     * get support count footer display
     */
    getSupportCount(): Observable<any> {
        return this.httpClient.get(CONSTANTS.APP.BASE_API_URL_ATUHENTICATION + CONSTANTS.API.ROUTE.SUPPORT.COUNT );
    }

    /**
     * get support detail ticket 
     * @returns 
     */
    getSupportTicketDetail(ticketId): Observable<any> {
        return this.httpClient.get(CONSTANTS.APP.BASE_API_URL_ATUHENTICATION + CONSTANTS.API.ROUTE.SUPPORT.DETAIL + ticketId );
    }
    
    /**
     * post support response
     * @param responseDto 
     * @returns 
     */
    postSupportResponse(responseDto): Observable<any> { 
        return this.httpClient.post(CONSTANTS.APP.BASE_API_URL_ATUHENTICATION + CONSTANTS.API.ROUTE.SUPPORT.POST_RESPONSE, responseDto);
    }
    
    /**
     * ticket status update
     * @param responseDto 
     * @returns 
     */
    ticketStatusUpdate(responseDto): Observable<any> { 
        return this.httpClient.put(CONSTANTS.APP.BASE_API_URL_ATUHENTICATION + CONSTANTS.API.ROUTE.SUPPORT.STATUS_UPDATE, responseDto);
    }

    /**
     * post help query
     * @param responseDto 
     * @returns 
     */
    postHelpQuery(responseDto): Observable<any> { 
        return this.httpClient.post(CONSTANTS.APP.BASE_API_URL_ATUHENTICATION + CONSTANTS.API.ROUTE.SUPPORT.POST_QUERY, responseDto);
    }
    

   
   
}  